export const formatMarkerLabel = ({ properties }) => {
  switch (properties.length) {
  case 0:
    return '';
  case 1:
    return '1';
  default:
    return properties.length;
  }
};

export const groupPropertiesByLocation = (properties) => {
  const map = {};
  properties.forEach(property => {
    const key = `${property.location.lat}-${property.location.lng}`;
    if (map[key]) { map[key].properties.push(property) } else { map[key] = { location: property.location, neighbourhood: property.neighbourhood.slug, properties: [property] } }
  });

  return Object.values(map).map((value, id) => ({ ...value, id, label: formatMarkerLabel(value) }));
};

export const groupPropertiesByNeighborhood = (properties) => {
  const map = {};
  if (properties.length) {
    properties.forEach(property => {
      const neighbourhoodSlug = property.neighbourhood.slug;
      if (map[neighbourhoodSlug]) {
        map[neighbourhoodSlug].properties.push(property);
        map[neighbourhoodSlug].location = {
          lat: property.neighbourhood.latitude,
          lng: property.neighbourhood.longitude
        };
      } else {
        map[neighbourhoodSlug] = { location: property.location, neighbourhood: property.neighbourhood.slug, properties: [property] };
      }
    });
  }

  return Object.values(map).map((value, id) => ({ ...value, id, label: formatMarkerLabel(value) }));
};

export const DEFAULT_LOCATION = {
  lat: -23.5867625,
  lng: -46.6799476
};
